import { useFormikContext } from "formik";
import _ from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import { VIEW_MODE } from "../../../Utils/GlobalValues";
import CsplTermsAndConditions from "../../CsplControls/CsplTermsAndConditions/CsplTermsAndConditions";
import ESignAndTermsAndConditionsResource from "../../Resources/ESignAndTermsAndConditionsResource/ESignAndTermsAndConditionsResource";
import Preview from "./Preview";
import { exportData } from "../../../Utils/FileExportUtils";
import CsplBackDropLoading from "../../CsplControls/CsplLoader/CsplBackDropLoading";
import CsplPreviewModal from "../../CsplControls/CsplPreviewModal/CsplPreviewModal";
import {TermsAndConditions} from "../../../Utils/GlobalValues"
import { SessionKeyEnum } from "../../../Enumeration/SessionKeyEnum";

function ESignAndTermsAndConditions() {
  const { t } = useTranslation("common");
  const [clicked, setClicked] = useState(false);
  const [requestEsign,eSignedKycApplication,getESignTermsAndConditions] =
    ESignAndTermsAndConditionsResource();
  const applicationContext = useContext(KycApplicationContext);
  const holderType = applicationContext.currentHolder.entityTypeShortName;
  let formMode = applicationContext.mode;
  const [checked, setChecked] = useState(false);
  const [showTermsAndConditions , setShowTermsAndConditions] = useState(false);
  const { values, setFieldValue } = useFormikContext();
  const [fileBase64String, setTermsAndConditionsFile] = useState("");
  const [fileName, setFileName] = useState(TermsAndConditions);

  //get the terms and conditions and display it
  function setTermsAndConditionsShow(){
    getESignTermsAndConditions().then(
      (res) => {

        if(!_.isEmpty(res)){
          // set the file base 64
          setTermsAndConditionsFile(res);

          // show the terms and conditions
          setShowTermsAndConditions(true);
        }

      },
      (error) => {      
      }
    );
    
  }

  function setTermsAndConditionsClose(){
    setShowTermsAndConditions(false);
  }

  useEffect(() => {
    setFieldValue(
      "eSignDocumentInfoDTO.termsAndConditionsAccepted",
      checked || applicationContext.currentWidget.status === "Completed"
    );
  }, []);

  // create the form elements and submit ti
  function prepareAndPostXmlString(xmlDTO) {
    // convert the string to object
    //let xmlDTO = JSON.parse(xmlDTOString);

    // create the form object and set action and method
    let form = document.getElementById("esignForm");
    form.method = "POST";
    form.action = xmlDTO.vendorUrl;

    // create xml string element
    let esignXmlStringElement = document.createElement("input");
    esignXmlStringElement.value = xmlDTO.requestXml;
    esignXmlStringElement.name = "msg";
    esignXmlStringElement.type = "hidden";
    form.appendChild(esignXmlStringElement);

    //append the form
    document.body.appendChild(form);

    // submit the form
    form.submit();

    // remove the form element , else on clicking following next the prev element will get appended
    form.removeChild(esignXmlStringElement);
  }

  // get the xml string
  function getEsignRequestXmlString() {
    // request for esign and get data based on session id
    requestEsign(sessionStorage.getItem(SessionKeyEnum.AppKey),holderType,values.eSignDocumentInfoDTO.termsAndConditionsAccepted).then(
      (res) => {
        if (res && res !== "") {
          // prepare the data to be posted and send the post request
          prepareAndPostXmlString(res);
        }else{
          setClicked(false);
        }
        
      },
      (error) => {
        setClicked(false);
      }
    );
  }

  // request for esign
  function handleRequestEsign(event) {
    event.preventDefault();
    if (clicked == false) {
      setClicked(true);
      getEsignRequestXmlString();
    }
  }

   //download Application
  function downloadApplication() {
    
     eSignedKycApplication(sessionStorage.getItem(SessionKeyEnum.AppKey)).then(
        (res) => {
          if (res && res.fileContent) {
            exportData(res.fileContent, res.fileName,res.fileExtension);
          }
        },
        (error) => {}
      );
  
  } 

  return (
    <React.Fragment>
      <form id="esignForm" name="esignForm" enctype="multipart/formdata"></form>
      {clicked &&
          <CsplBackDropLoading showLoading={clicked}></CsplBackDropLoading> }
      <div className="height-90">
        <Preview ondownload={downloadApplication} showDownload={true} accordionkey={null}></Preview>

        {
          <div className="modal_KycGuide p-4">
            <CsplTermsAndConditions
              description={<>{t("esign.esignTermsAndConditionsText")}</>}
              disabled={
                formMode === VIEW_MODE ||
                applicationContext.currentWidget.status === "Completed"
              }
              name="eSignDocumentInfoDTO.termsAndConditionsAccepted"
              label={"termsAndCondition.agreeTermsAndConditionText"}
              showlinktext={false}
              onlinkclick = {setTermsAndConditionsShow}
            ></CsplTermsAndConditions>
          </div>
        }

        {showTermsAndConditions &&
          <CsplPreviewModal        
            showPreview={showTermsAndConditions}
            onClose={setTermsAndConditionsClose}
            fileName={fileName}        
            base64String={fileBase64String}
            ></CsplPreviewModal>
        }


         {/* <div className="col-sm-11 w-100 me-3">&nbsp;</div>  */}
        <div className="applyDigitalSign me-4 p-0 mb-4">
          {formMode !== VIEW_MODE &&
            applicationContext.currentWidget.status !== "Completed" && (
              <Button
                className="btn shadow-none ok_btn cursor_pointer font-size-13 mb-5"
                disabled={
                  !values.eSignDocumentInfoDTO.termsAndConditionsAccepted ||
                  clicked
                }
                onClick={(event) => handleRequestEsign(event)}
              >
                {t("esign.signApplicationDigitally")}
              </Button>
            )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default ESignAndTermsAndConditions;
